export default __webpack_public_path__ + "static/media/logo7.8e813045.svg";